import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';

export const Link = styled(RouterLink)`
    &:hover {
        text-decoration: none;
    }
`;
